import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import SectionLast from './sectionlast/SectionLast';
import loader from './assets/loadergif.gif';
import NavbarUi from './navbar/navbar';
import HeroSection from './herosection/hero';
import Features from './features/features';
import About from './about/about';
import Tokens from './tokens/tokens';
import Footer from './footer/footer';

function LandingPage() {
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem('token');
    const navigate = useNavigate();

    useEffect(() => {
        if (token) navigate('/user');
        const timer = setTimeout(() => setLoading(false), 2000);
        return () => clearTimeout(timer);
    }, [token, navigate]);

    if (loading) {
        return (
            <div className="fixed inset-0 bg-[#0a0a1a] flex items-center justify-center z-50">
                <div className="flex flex-col items-center justify-center">

                    <div className="h-16 w-16 rounded-full border-4 border-emerald-400 border-t-transparent animate-spin"></div>

                    <p className="text-gray-400 text-lg mt-6 tracking-widest uppercase">
                        Loading Ellipticline...
                    </p>

                </div>
            </div>
        );
    }

    return (
        <div className="bg-[#0a0a1a] min-h-screen">

            <NavbarUi />

            <div className="container mx-auto">
                <HeroSection />
                <Features />
                <About />
                <Tokens />
                <SectionLast />
            </div>

            <Footer />

        </div>
    );
}

export default LandingPage;